(function () {
  var root = document.querySelector('[data-mtt-tracking-center]');
  if (!root) return;

  var form = root.querySelector('[data-track-form]');
  var results = root.querySelector('[data-track-results]');
  var error = root.querySelector('[data-track-error]');
  var submit = root.querySelector('[data-track-submit]');
  var submitLabel = root.querySelector('[data-submit-label]');
  var recentList = root.querySelector('[data-customer-orders]');
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-track-mode]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-mode-panel]'));
  var activeMode = 'order';
  var lookupEndpoint = root.getAttribute('data-lookup-endpoint') || '';
  var customerSignedIn = root.getAttribute('data-customer-signed-in') === 'true';
  var recentOrders = parseJson(root.querySelector('[data-customer-order-json]'), []);
  var serviceRecords = parseJson(root.querySelector('[data-service-record-json]'), []);

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      setMode(tab.getAttribute('data-track-mode'));
    });
  });

  bindRecentButtons();

  if (customerSignedIn && lookupEndpoint) {
    loadCustomerRecords();
  }

  function bindRecentButtons() {
    root.querySelectorAll('[data-order-index]').forEach(function (button) {
      if (button.getAttribute('data-track-bound') === 'true') return;
      button.setAttribute('data-track-bound', 'true');
      button.addEventListener('click', function () {
        var index = Number(button.getAttribute('data-order-index'));
        if (recentOrders[index]) renderResult(recentOrders[index]);
      });
    });

    root.querySelectorAll('[data-service-index]').forEach(function (button) {
      if (button.getAttribute('data-track-bound') === 'true') return;
      button.setAttribute('data-track-bound', 'true');
      button.addEventListener('click', function () {
        var index = Number(button.getAttribute('data-service-index'));
        if (serviceRecords[index]) renderResult(serviceRecords[index]);
      });
    });
  }

  function loadCustomerRecords() {
    fetch(lookupEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ mode: 'customer' })
    })
      .then(parseResponse)
      .then(function (data) {
        var records = Array.isArray(data.records) ? data.records.filter(function (record) {
          return record && record.type !== 'order';
        }) : [];
        records.forEach(function (record) {
          var normalized = normalizeRecord(record);
          var exists = serviceRecords.some(function (existing) {
            return normalizeRecord(existing).reference === normalized.reference;
          });
          if (!exists) serviceRecords.push(normalized);
        });
        renderCustomerServiceButtons();
      })
      .catch(function () {
        return null;
      });
  }

  function renderCustomerServiceButtons() {
    if (!recentList) return;
    recentList.querySelectorAll('[data-dynamic-service]').forEach(function (node) {
      node.remove();
    });
    serviceRecords.forEach(function (record, index) {
      if (recentList.querySelector('[data-service-index="' + index + '"]:not([data-dynamic-service])')) return;
      var normalized = normalizeRecord(record);
      var button = document.createElement('button');
      button.className = 'mtt-order-mini';
      button.type = 'button';
      button.setAttribute('data-service-index', String(index));
      button.setAttribute('data-dynamic-service', 'true');
      button.innerHTML = '<span><strong>' + escapeHtml(normalized.reference) + '</strong><small>' + escapeHtml(normalized.date || 'Service record') + '</small></span><em>' + escapeHtml(normalized.currentStatus) + '</em>';
      recentList.appendChild(button);
    });
    bindRecentButtons();
    var empty = root.querySelector('[data-recent-empty]');
    if (empty && (recentOrders.length || serviceRecords.length)) empty.classList.add('is-hidden');
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    hideError();

    var payload = buildPayload();
    var validation = validatePayload(payload);
    if (!validation.valid) {
      showError(validation.message);
      return;
    }

    if (!lookupEndpoint) {
      showError('Manual lookup needs a secure Midwest Turf Tech lookup endpoint before order, phone, or tracking results can be shown. Signed-in customers can still open recent Shopify orders here.');
      return;
    }

    setLoading(true);
    fetch(lookupEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    })
      .then(parseResponse)
      .then(function (data) {
        if (!data || !data.record) {
          showError('We could not find a matching record. Check the details and try again, or contact support for help.');
          return;
        }
        renderResult(normalizeRecord(data.record));
      })
      .catch(function (lookupError) {
        showError(lookupError && lookupError.message ? lookupError.message : 'We could not complete that lookup right now. Please try again in a few minutes or contact support.');
      })
      .finally(function () {
        setLoading(false);
      });
  });

  function setMode(mode) {
    activeMode = mode;
    tabs.forEach(function (tab) {
      var isActive = tab.getAttribute('data-track-mode') === mode;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    panels.forEach(function (panel) {
      panel.classList.toggle('is-hidden', panel.getAttribute('data-mode-panel') !== mode);
    });
    var phoneMode = mode === 'phone';
    submit.disabled = phoneMode;
    submitLabel.textContent = phoneMode ? 'Verification coming soon' : 'Track status';
    hideError();
  }

  function buildPayload() {
    var formData = new FormData(form);
    return {
      mode: activeMode,
      orderNumber: sanitizeText(formData.get('order_number')),
      email: sanitizeText(formData.get('email')).toLowerCase(),
      trackingNumber: sanitizeText(formData.get('tracking_number')),
      phone: normalizePhone(formData.get('phone'))
    };
  }

  function validatePayload(payload) {
    if (payload.mode === 'order') {
      if (payload.orderNumber.length < 3) return invalid('Enter a valid order, repair, or parts reference number.');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) return invalid('Enter the email address used for the order or request.');
    }
    if (payload.mode === 'tracking' && payload.trackingNumber.length < 8) {
      return invalid('Enter a complete carrier tracking number.');
    }
    if (payload.mode === 'phone' && payload.phone.length < 10) {
      return invalid('Phone lookup will be available after secure text verification is configured.');
    }
    return { valid: true };
  }

  function invalid(message) {
    return { valid: false, message: message };
  }

  function normalizeRecord(record) {
    return {
      type: record.type || 'order',
      reference: record.reference || record.name || 'Tracking record',
      date: record.date || record.createdAt || '',
      customerName: record.customerName || '',
      currentStatus: record.currentStatus || record.status || 'Processing',
      statusKey: record.statusKey || handleize(record.currentStatus || record.status || 'processing'),
      statusDescription: record.statusDescription || statusDescription(record.currentStatus || record.status),
      carrierName: record.carrierName || '',
      trackingNumber: record.trackingNumber || '',
      trackingUrl: record.trackingUrl || '',
      items: Array.isArray(record.items) ? record.items : [],
      events: Array.isArray(record.events) && record.events.length ? record.events : fallbackEvents(record)
    };
  }

  function renderResult(rawRecord) {
    var record = normalizeRecord(rawRecord);
    results.innerHTML =
      '<article class="mtt-result">' +
        '<div class="mtt-result__summary">' +
          '<div>' +
            '<span class="mtt-result__kicker">' + escapeHtml(typeLabel(record.type)) + '</span>' +
            '<h2>' + escapeHtml(record.reference) + '</h2>' +
            '<span class="mtt-status-pill">' + escapeHtml(record.currentStatus) + '</span>' +
            '<p>' + escapeHtml(record.statusDescription) + '</p>' +
            '<div class="mtt-result__meta">' +
              metaBlock('Date', record.date || 'Not available') +
              metaBlock('Carrier', record.carrierName || 'Not available yet') +
              metaBlock('Tracking', record.trackingNumber || 'Not available yet') +
            '</div>' +
          '</div>' +
          trackingLink(record) +
        '</div>' +
        '<div class="mtt-result__panel">' +
          '<h3>Status timeline</h3>' +
          '<div class="mtt-timeline">' + record.events.map(function (event, index) {
            var isCurrent = index === record.events.length - 1;
            return '<div class="mtt-timeline__event' + (isCurrent ? ' is-current' : '') + '">' +
              '<span class="mtt-timeline__dot" aria-hidden="true"></span>' +
              '<div class="mtt-timeline__body">' +
                '<strong>' + escapeHtml(event.label || 'Status update') + '</strong>' +
                (event.timestamp ? '<time>' + escapeHtml(event.timestamp) + '</time>' : '') +
                '<p>' + escapeHtml(event.description || event.location || '') + '</p>' +
              '</div>' +
            '</div>';
          }).join('') + '</div>' +
        '</div>' +
        '<div class="mtt-result__panel">' +
          '<h3>Items</h3>' +
          renderItems(record.items) +
        '</div>' +
      '</article>';
  }

  function metaBlock(label, value) {
    return '<div><span>' + escapeHtml(label) + '</span><strong>' + escapeHtml(value) + '</strong></div>';
  }

  function trackingLink(record) {
    var url = safeUrl(record.trackingUrl);
    if (!url) return '';
    return '<a class="mtt-button mtt-button--primary" href="' + escapeAttribute(url) + '" target="_blank" rel="noopener noreferrer">Open details</a>';
  }

  function renderItems(items) {
    if (!items.length) return '<p>No item details are available for this record yet.</p>';
    return '<div class="mtt-item-list">' + items.map(function (item) {
      var imageUrl = safeUrl(item.image);
      var image = imageUrl ? '<img src="' + escapeAttribute(imageUrl) + '" alt="">' : '<span class="mtt-item__thumb" aria-hidden="true"></span>';
      return '<div class="mtt-item">' + image + '<div><span>' + escapeHtml(item.title || 'Item') + '</span><small>Qty ' + escapeHtml(String(item.quantity || 1)) + '</small></div></div>';
    }).join('') + '</div>';
  }

  function fallbackEvents(record) {
    var status = record.currentStatus || 'Processing';
    return [
      { label: 'Order received', timestamp: record.date || '', description: 'Your record has been created with Midwest Turf Tech.' },
      { label: status, timestamp: '', description: statusDescription(status) }
    ];
  }

  function statusDescription(status) {
    var descriptions = {
      'Waiting on manufacturer': 'We are currently waiting on the manufacturer to supply the required part or update needed to move your job forward.',
      'Part ordered': 'Your required part has been ordered and we are waiting for it to arrive.',
      'In diagnosis': 'Your machine is currently being inspected and diagnosed by our service team.',
      'In transit': 'Your shipment is moving through the carrier network.',
      'Out for delivery': 'Your shipment is scheduled to arrive soon.',
      'Delivered': 'The carrier has marked this shipment as delivered.',
      'Fulfilled': 'Your order has been fulfilled. Use the carrier link for detailed transit updates.',
      'Processing': 'Your order is being reviewed and prepared by Midwest Turf Tech.',
      'Order received': 'We have received your order or service request.'
    };
    return descriptions[status] || 'We are tracking this record and will update the status as progress is made.';
  }

  function typeLabel(type) {
    if (type === 'repair') return 'Repair status';
    if (type === 'parts') return 'Parts order';
    return 'Order status';
  }

  function showError(message) {
    error.textContent = message;
    error.classList.remove('is-hidden');
  }

  function hideError() {
    error.textContent = '';
    error.classList.add('is-hidden');
  }

  function setLoading(isLoading) {
    submit.classList.toggle('is-loading', isLoading);
    submit.disabled = isLoading;
  }

  function parseJson(node, fallback) {
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return fallback;
    }
  }

  function parseResponse(response) {
    return response.json().catch(function () { return {}; }).then(function (data) {
      if (!response.ok) throw new Error(data.error || 'We could not complete that lookup right now.');
      return data;
    });
  }

  function sanitizeText(value) {
    return String(value || '').replace(/[<>]/g, '').trim().slice(0, 120);
  }

  function normalizePhone(value) {
    return String(value || '').replace(/\D/g, '').slice(-15);
  }

  function handleize(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/`/g, '&#096;');
  }

  function safeUrl(value) {
    var url = String(value || '').trim();
    return /^(https?:\/\/|\/)/i.test(url) ? url : '';
  }
})();
